import { render, staticRenderFns } from "./product-summary-travel-insurance-card.vue?vue&type=template&id=aeeb1420&scoped=true"
import script from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./product-summary-travel-insurance-card.vue?vue&type=style&index=0&id=aeeb1420&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeb1420",
  null
  
)

export default component.exports